import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import Button from '@material-ui/core/Button'
import AccordionList from '@components/accordion-list/accordion-list'
import LinearProgress from '@material-ui/core/LinearProgress'
import { useQuery } from '@apollo/client'
import associateProgramFaqQuery, { CUSTOM_PAGE_FAQ_QUERY } from './queries'
import useStyles from './faq.styles'

const FAQ = (props) => {
  const {
    headline,
    categories,
    collectionName,
    slug,
    heading,
  } = props

  const styles = useStyles()
  const [selectedCategory, setSelectedCategory] = useState(categories ? categories[0] : categories)

  const router = useRouter()
  const targetItemParam = router?.query?.openCategory

  useEffect(() => {
    if (targetItemParam) {
      const targetCategory = categories.find((item) => {
        const formattedCategory = item.replace(/\s+/g, '').toLowerCase()
        return formattedCategory === targetItemParam
      })
      if (targetCategory) {
        setSelectedCategory(targetCategory)
      }
    }
  }, [])

  const handleCategoryClick = (clickedCategory) => {
    if (clickedCategory !== selectedCategory) {
      setSelectedCategory(clickedCategory)
    }
  }

  const { data, loading } = slug === 'associate-program'
    ? useQuery(associateProgramFaqQuery, {
      variables: {
        category: selectedCategory,
      },
    })
    : useQuery(CUSTOM_PAGE_FAQ_QUERY, {
      variables: {
        slug,
        heading,
        category: selectedCategory,
      },
    })

  const questionsCollection = slug === 'associate-program'
    ? data?.[collectionName]?.items[0]?.faq?.itemsCollection
    : data?.customPageCollection?.items[0]?.contentSectionsCollection?.items[0]?.itemsCollection

  return (
    <div className={styles.root}>
      <Container>
        <Typography className={styles.headline} variant="h3">{headline}</Typography>
        {categories?.length > 0 && (
          <>
            <Box
              className={styles.categoryTagsRow}
              role="group"
              aria-label={`${headline} category buttons`}
            >
              {categories.map(item => (
                <Button
                  onClick={() => handleCategoryClick(item)}
                  key={item}
                  className={`${styles.categoryTags} ${item === selectedCategory ? styles.active : ''}`}
                  aria-pressed={selectedCategory === item}
                >{item}
                </Button>
              ))}
            </Box>
            <Box className={styles.divider} />
          </>
        )}
        {loading && <div className={styles.loadingContainer}><LinearProgress color="secondary" /></div>}
        {questionsCollection?.items?.length > 0 ? (
          <div className={styles.accordionContainer}>
            <AccordionList itemsCollection={questionsCollection} />
          </div>
        ) : (
          !loading && (
            <div
              data-testid="no-results-page"
              className={styles.noResultsContainer}
            >
              <Typography variant="h5" className={styles.noResultsTitle}>
                No questions in this category.
              </Typography>
              <Typography variant="body1" className={styles.noResultsBody}>
                Please select a different option.
              </Typography>
            </div>
          )
        )}
      </Container>
    </div>
  )
}

FAQ.propTypes = {
  headline: PropTypes.string,
  categories: PropTypes.array,
  collectionName: PropTypes.string,
  slug: PropTypes.string,
  heading: PropTypes.string,
}

export default FAQ
